import jwt_decode from "jwt-decode";
import { usePermissions } from "../contexts/PermissionContext";

export const TYPE_INFO = {
  INCOME: {
    title: "Misc Income",
    newLabel: "New Receipt",
    partyLabel: "Received From",
    color: "#198754",
    permission: "Misc_Income",
    receiptTitle: "MONEY RECEIPT",
  },
  EXPENSE: {
    title: "Misc Expense",
    newLabel: "New Payment",
    partyLabel: "Paid To",
    color: "#dc3545",
    permission: "Misc_Expense",
    receiptTitle: "PAYMENT VOUCHER",
  },
};

export const PAYMENT_METHODS = ["Cash", "UPI", "Cheque", "Bank Transfer", "Card"];

export const num = (v) => {
  const n = Number(String(v ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
};
export const inr = (v) =>
  num(v).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const monthStart = () => today().slice(0, 8) + "01";
export const fmtDate = (s) => {
  if (!s) return "";
  const [y, m, d] = String(s).slice(0, 10).split("-");
  return d && m && y ? `${d}-${m}-${y}` : String(s);
};

export const partyName = (e) =>
  e?.party_type === "STUDENT" ? e?.student_name : e?.staff_name || e?.party_name || "";

export const userInfo = () => {
  try {
    return jwt_decode(sessionStorage.getItem("token"));
  } catch {
    return {};
  }
};

/** can the logged-in user do `action` (read|create|edit|delete) on this module permission key */
export const useCan = (permKey) => {
  const { rolePermissions, userInfo: u } = usePermissions();
  const role = u?.userrole;
  const admin = role === "SYS_ADMIN" || role === "ADMIN";
  const p = (rolePermissions || {})[permKey] || {};
  return {
    read: admin || !!p.can_read,
    create: admin || !!p.can_create,
    edit: admin || !!p.can_edit,
    del: admin || !!p.can_delete,
  };
};

/* amount in words (Indian system) for receipts */
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven",
  "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
const two = (n) => (n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]}${n % 10 ? " " + ONES[n % 10] : ""}`);
const three = (n) => {
  const h = Math.floor(n / 100);
  const r = n % 100;
  return [h ? `${ONES[h]} Hundred` : "", r ? two(r) : ""].filter(Boolean).join(" ");
};
export const amountInWords = (value) => {
  let n = Math.floor(num(value));
  if (n === 0) return "Zero Rupees Only";
  const parts = [];
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  if (crore) parts.push(`${three(crore)} Crore`);
  if (lakh) parts.push(`${two(lakh)} Lakh`);
  if (thousand) parts.push(`${two(thousand)} Thousand`);
  if (n) parts.push(three(n));
  const paise = Math.round((num(value) % 1) * 100);
  return `${parts.join(" ")} Rupees${paise ? ` and ${two(paise)} Paise` : ""} Only`;
};
